/**
 * Do not edit directly
 * Generated on Thu, 29 Sep 2022 18:15:25 GMT
 */

export const componentDataTableBulkActionsActionContentAlignHorizontalBS = "center";
export const componentDataTableBulkActionsActionContentAlignHorizontalBM = "end";
export const componentDataTableBulkActionsActionContentAlignVertical = "center";
export const componentDataTableBulkActionsActionContentGrowFactor = 1;
export const componentDataTableBulkActionsContainerAlignHorizontalBS = "center";
export const componentDataTableBulkActionsContainerAlignHorizontalBM = "space-between";
export const componentDataTableBulkActionsContainerAlignVertical = "center";
export const componentDataTableBulkActionsContainerBackgroundColor = "#e6f1fc";
export const componentDataTableBulkActionsContainerBorderColor = "#004f9a";
export const componentDataTableBulkActionsContainerBorderRadius = "0.25rem";
export const componentDataTableBulkActionsContainerBorderWidth = "0.0625rem";
export const componentDataTableBulkActionsContainerDirectionBS = "column";
export const componentDataTableBulkActionsContainerDirectionBM = "row";
export const componentDataTableBulkActionsContainerElevation = "0 0.1875rem 0.3125rem 0.125rem rgba(0, 0, 0, 0.15), 0 -0.0625rem 0.1875rem 0 rgba(0, 0, 0, 0.10)";
export const componentDataTableBulkActionsContainerGap = "1rem";
export const componentDataTableBulkActionsContainerPadding = "1rem";
export const componentDataTableBulkActionsContentAlignVertical = "center";
export const componentDataTableBulkActionsIconIconColor = "#004f9a";
export const componentDataTableBulkActionsIconIconName = "Check";
export const componentDataTableBulkActionsIconIconSize = "medium";
export const componentDataTableBulkActionsIconMarginRight = "0.75rem";
export const componentDataTableBulkActionsIconShrinkFactor = 0;
export const componentDataTableBulkActionsTextLabelAliasName = "component.text.body";
export const componentDataTableBulkActionsTextLabelAliasOptionsSize = "medium";
export const componentDataTableBulkActionsTextLabelAliasOptionsWeight = 700;
export const componentDataTableBulkActionsTextLabelMarginRight = "1rem";
export const componentDataTableBulkActionsTextLabelTextColor = "#004f9a";
export const componentDataTableCellAliasName = "component.text.body";
export const componentDataTableCellAliasOptionsSize = "medium";
export const componentDataTableCellPadding = "1rem";
export const componentDataTableCellVariantAlphanumericTextAlign = "left";
export const componentDataTableCellVariantNumericAliasOptionsIsMonospace = true;
export const componentDataTableCellVariantNumericTextAlign = "right";
export const componentDataTableCellActionsAlignHorizontal = "flex-end";
export const componentDataTableCellActionsGap = "0.25rem";
export const componentDataTableCellActionsPaddingHorizontal = "1rem";
export const componentDataTableCellActionsPaddingVertical = "0.75rem";
export const componentDataTableCellActionsMenuContainerBackgroundColor = "#fff";
export const componentDataTableCellActionsMenuContainerBorderRadius = "0.25rem";
export const componentDataTableCellActionsMenuContainerElevation = "0 0.3125rem 0.625rem 0.1875rem rgba(0, 0, 0, 0.15), 0 -0.0625rem 0.25rem 0 rgba(0, 0, 0, 0.10)";
export const componentDataTableCellActionsMenuContainerGap = "0.75rem";
export const componentDataTableCellActionsMenuContainerMinWidth = "8rem";
export const componentDataTableCellActionsMenuContainerPadding = "1rem";
export const componentDataTableCellActionsMenuItemAlignVertical = "flex-start";
export const componentDataTableCellActionsMenuItemLeadingIconIconSize = "small";
export const componentDataTableCellActionsMenuItemLeadingIconMarginRight = "0.5rem";
export const componentDataTableCellActionsMenuItemLeadingIconMarginTop = "0.125rem";
export const componentDataTableCellActionsMenuItemTextLabelFontFamily = "Bogle, 'Helvetica Neue', Helvetica, Arial, sans-serif";
export const componentDataTableCellActionsMenuItemTextLabelFontSize = "0.875rem";
export const componentDataTableCellActionsMenuItemTextLabelFontWeight = "400";
export const componentDataTableCellActionsMenuItemTextLabelLineHeight = "1.25rem";
export const componentDataTableCellActionsMenuItemTextLabelTextColorDefault = "#000";
export const componentDataTableCellActionsMenuItemTextLabelTextColorHover = "#004f9a";
export const componentDataTableCellActionsMenuItemTextLabelTextColorFocus = "#004f9a";
export const componentDataTableCellActionsMenuItemTextLabelTextColorActive = "#002d58";
export const componentDataTableCellActionsMenuItemTextLabelTextDecorationDefault = "underline";
export const componentDataTableCellActionsMenuItemTextLabelTextDecorationHover = "none";
export const componentDataTableCellActionsMenuItemTextLabelTextDecorationFocus = "none";
export const componentDataTableCellActionsMenuItemTextLabelTextDecorationActive = "none";
export const componentDataTableCellActionsMenuItemTextLabelWhiteSpace = "nowrap"; // TODO: figure this out
export const componentDataTableCellActionsMenuLayoutContainerOffsetTop = "0.25rem";
export const componentDataTableCellActionsMenuLayoutContainerZIndex = "100";
export const componentDataTableCellActionsMenuNubbinBackgroundColor = "#fff";
export const componentDataTableCellActionsMenuNubbinElevation = "0 0.3125rem 0.625rem 0.1875rem rgba(0, 0, 0, 0.15), 0 -0.0625rem 0.25rem 0 rgba(0, 0, 0, 0.10)";
export const componentDataTableCellActionsMenuNubbinHeight = "0.5rem";
export const componentDataTableCellActionsMenuNubbinOffsetRight = "0.5rem";
export const componentDataTableCellActionsMenuNubbinWidth = "1rem";
export const componentDataTableCellSelectAlignVertical = "flex-start";
export const componentDataTableCellSelectCheckboxAliasName = "component.checkbox";
export const componentDataTableCellSelectContainerPadding = "1rem";
export const componentDataTableCellSelectContainerWidth = "3.25rem";
export const componentDataTableCellStatusPadding = "1rem";
export const componentDataTableHeaderAlignVertical = "center";
export const componentDataTableHeaderAlignmentLeftAlignHorizontal = "flex-start";
export const componentDataTableHeaderAlignmentLeftTextAlign = "left";
export const componentDataTableHeaderAlignmentRightAlignHorizontal = "flex-end";
export const componentDataTableHeaderAlignmentRightTextAlign = "right";
export const componentDataTableHeaderBackgroundColor = "#f8f8f8";
export const componentDataTableHeaderPadding = "1rem";
export const componentDataTableHeaderStateIsSortableBackgroundColorDefault = "#f8f8f8";
export const componentDataTableHeaderStateIsSortableBackgroundColorHover = "#f1f1f2";
export const componentDataTableHeaderStateIsSortableBackgroundColorFocus = "#f1f1f2";
export const componentDataTableHeaderStateIsSortableBackgroundColorActive = "#f1f1f2";
export const componentDataTableHeaderIconAlignmentLeftMarginLeft = "0.25rem";
export const componentDataTableHeaderIconAlignmentRightMarginRight = "0.25rem";
export const componentDataTableHeaderIconIconColor = "#74767c";
export const componentDataTableHeaderIconIconSize = "small";
export const componentDataTableHeaderIconSortAscendingIconColor = "#000";
export const componentDataTableHeaderIconSortAscendingIconName = "ArrowUp";
export const componentDataTableHeaderIconSortAscendingVisibility = "visible";
export const componentDataTableHeaderIconSortDescendingIconColor = "#000";
export const componentDataTableHeaderIconSortDescendingIconName = "ArrowDown";
export const componentDataTableHeaderIconSortDescendingVisibility = "visible";
export const componentDataTableHeaderIconVisibilityDefault = "hidden";
export const componentDataTableHeaderIconVisibilityHover = "visible";
export const componentDataTableHeaderIconVisibilityFocus = "visible";
export const componentDataTableHeaderSelectAlignVertical = "center";
export const componentDataTableHeaderSelectCheckboxAliasName = "component.checkbox";
export const componentDataTableHeaderSelectContainerBackgroundColor = "#f8f8f8";
export const componentDataTableHeaderSelectContainerPadding = "1rem";
export const componentDataTableHeaderSelectContainerWidth = "3.25rem";
export const componentDataTableHeaderTextLabelAliasName = "component.text.body";
export const componentDataTableHeaderTextLabelAliasOptionsSize = "medium";
export const componentDataTableHeaderTextLabelAliasOptionsWeight = 700;
export const componentDataTableRowBackgroundColorDefault = "#fff";
export const componentDataTableRowBackgroundColorHover = "#f1f1f2";
export const componentDataTableRowBorderBottomColor = "#e3e4e5";
export const componentDataTableRowBorderBottomWidth = "0.0625rem";
export const componentDataTableRowStateSelectedBackgroundColorDefault = "#f2f8fd";
export const componentDataTableRowStateSelectedBackgroundColorHover = "#e6f1fc";